import { Component, ElementRef, ViewChild } from "@angular/core";
import { AuthStatus } from "src/app/components/Shared/Model/AuthStatus";
import { Router } from "@angular/router";
import { LoginService } from "src/app/components/Shared/Service/login_service";
import { FormControl } from "@angular/forms";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map, startWith } from "rxjs/operators";
import * as $ from 'jquery';
import { interval } from 'rxjs';
import { Config } from "protractor";
import { DashboarduiService } from "./components/Shared/Service/dashboardui.service";
import { MatSelectChange, MatTableDataSource } from '@angular/material';
import { HostListener } from '@angular/core';
export interface HotelModal {
  pmsCustCode: string;
  hotelname: string;
}
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type:any
}
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [LoginService],
})
export class AppComponent {
  options: Config = { multi: false };
  selected: string;
  title = "Integrations 360 View";
  Islogin: boolean = false;
  today: number = Date.now();
  isIDSUser: boolean;
  masterHotelSearch = new FormControl();
  hotelList: Array<HotelModal>;
  filteredHotels$: Observable<HotelModal[]>;
  hotelInfolist: any = [];
  latestHeartBeat: string;
  windowsServiceVersionlist: any = [];
  @ViewChild("hotelAutoComplete", { static: false })
  hotelAutoCompleteElement: ElementRef;

  _filterChange = new BehaviorSubject({ pmsCustCode: "", hotelname: "" });
  isSidenavOpened: boolean;
  config: any;
  displaySignout: boolean;
  displayAlertPopup: boolean = false;
  alertData: any;
  filterProperty: idsProductList[];
  get filter(): HotelModal {
    return this._filterChange.value;
  }
  public idsProductList: idsProductList[];
  dataSource: MatTableDataSource<idsProductList>
  displayedColumns: string[] = ['flowType','status', 'createdatetime'];
  constructor(
    public route: Router,
    private _APISERVICE: LoginService,
    private apiCallIdsService: DashboarduiService,
  ) {}
  User: string;
  user: any = ([] = []);
  lstuser: any = ([] = []);
  lstproduct: any = ([] = []);
  menuheaders: any = ([] = []);
  dismenuheaders: any = [];
  public Userid: any;
//Indhuja 28-01-2026 Start
idleTimeout: any;
IDLE_TIME = 30 * 60 * 1000; // 30 minutes
//IDLE_TIME = 30 * 1000; // 30 seconds
//Indhuja 28-01-2026 End
  LinkClicked() {
    this.displaySignout = true
  }

  signoutConfirmBtn(res:any) {
    if(res=="yes"){
    // localStorage.removeItem("SearchHotelSelected");
      // localStorage.clear();
      // location.reload();
      // window.location.reload()
      // Cookie.deleteAll();
      
      this.displaySignout = false
      this.Islogin = false;
      
    }else {
      this.displaySignout = false
    }
  }
  // this.route.navigate(["/login"]);
  LinkClicked1() {
    
    this.route.navigate(["/dashboard"]);
    $('.hamberger').toggleClass("click");
    $('.sidenav').toggleClass("show");
  }

  ngOnInit() {
    this.isSidenavOpened = false
    this.config = this.mergeConfig(this.options);
    
  }

  mergeConfig(options: Config) {
    const config = {
      // selector: '#accordion',
      multi: true
    };

    return { ...config, ...options };
  }
@HostListener('window:mousemove')
  @HostListener('window:keydown')
  @HostListener('window:click')
  @HostListener('window:scroll')
  resetIdleTimer() {
    if (this.Islogin) {
      this.startIdleTimer();
    }
  }

  startIdleTimer() {
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
    }

    this.idleTimeout = setTimeout(() => {
      console.log('Auto logout after 30 minutes inactivity');
      this.autoLogout();
    }, this.IDLE_TIME);
  }

  autoLogout() {
    clearTimeout(this.idleTimeout);
    localStorage.clear();
    this.Islogin = false;
    this.route.navigate(['/login']);
  }

  private _hotelFilter(value: string): HotelModal[] {
    console.log('119 =',value)
    const filterValue = value ? value.toLowerCase() : "";
    console.log('filterValue =',filterValue)
    return this.hotelList.filter((option) =>
      option.hotelname.toLowerCase().includes(filterValue)
    );
  }

  setSelectedHotel(selectedHotelFullName) {
    //alert('selectedHotelFullName = '+selectedHotelFullName)
    var selectedHotelid = selectedHotelFullName.split("-")[0];
    //alert('selectedHotelid = '+selectedHotelid)
    //this.Getproductbyuid(selectedHotelid, "productlistByHotelIDForIDS");
    this.Getproductbyuidforparticularuser(selectedHotelid, "productlistByHotelIDForIDSNew");
    localStorage.removeItem("SearchHotelSelected");
    let SearchHotelSelected = [
      { name: selectedHotelFullName, id: selectedHotelid },
    ];
    localStorage.setItem(
      "SearchHotelSelected",
      JSON.stringify(SearchHotelSelected)
    );
    this._APISERVICE
      .getHotelInfoByHotelId(selectedHotelid)
      .subscribe((data) => {
        if (!!data) {
          this.hotelInfolist = data[0];
        }
      });
    this.getWindowsServiceVersion(selectedHotelid);
    this.Getheartbeatdate(selectedHotelid);
    // return this.hotelList;
    // this.route.navigate(["/dashboard"]);
    return this.redirectTo("dashboard");
  }

  Getheartbeatdate(selectedHotelid: string) {
    this._APISERVICE.getHeartBeat(selectedHotelid).subscribe((data) => {
      if (!!data) {
        this.latestHeartBeat = data[0].heartBeat;
      }
    });
  }

  getWindowsServiceVersion(selectedHotelid: string) {
    this._APISERVICE
      .getWindowsServiceVersion(selectedHotelid)
      .subscribe((data) => {
        if (!!data) this.windowsServiceVersionlist = data[0];
      });
  }

  getMasterHotelList(search: string) {
    //alert(search+" = search")
    const filterValue = search.toLowerCase();
    //alert(filterValue+" = filterValue")
    this.masterHotelSearch.reset();
    this._APISERVICE
      .getMasterHotelsForIDSUsers(filterValue)
      .subscribe((data) => {
        console.log('getMasterHotelsForIDSUsers = ',data)
        this.filteredHotels$ = this.masterHotelSearch.valueChanges.pipe(startWith(""),map((value) => this._hotelFilter(value))
        );
        this.hotelList = data;
        //alert(this.hotelList+" = this.hotelList")
        //alert(this.filteredHotels$+" = this.filteredHotels$")
      });
    return this.hotelList;
  }

  clearHotelAutoComplete(evt: any): void {
    evt.stopPropagation();
    this.masterHotelSearch.reset();
    this.hotelAutoCompleteElement.nativeElement.focus();
    localStorage.removeItem("SearchHotelSelected");
    var selectedHotelid = "";
    this.hotelInfolist = [];
    this.windowsServiceVersionlist = [];
    this.latestHeartBeat = "";
    this.lstproduct = [];
    return this.redirectTo("dashboard");
  }

  loginChange(e) {
    
    this.Islogin = true;
    // var hoteldata = JSON.parse(localStorage.getItem("HotelList"));
    // this.hotellist = hoteldata;
    // this.selected = this.hotellist[0].id;

    localStorage.setItem("HotelCode", this.selected);
    this.Userid = localStorage.getItem("Username");
    console.log('App compontent User ID =', this.Userid)
    this.isIDSUser = this._APISERVICE.isIDSUser();
    // this.Getproductbyuid(this.Userid, "productlist");
    if(this.isIDSUser){
      this.alertPopupFunction();
      interval(10000 * 60).subscribe(() => {
        this.alertPopupFunction();
      });
      //this.Getproductbyuid("0", "productlistByHotelIDForIDSNew");
       this.Getproductbyuidforparticularuser(this.Userid, "productlistByHotelIDForIDSNew");
    }
    if(!this.isIDSUser){
      // this.toastr.error("This credential is only for IDS Users");
      //this.Getproductbyuid(this.Userid, "productlistByHotelIDForIDSNew");
       this.Getproductbyuidforparticularuser(this.Userid, "productlistByHotelIDForIDSNew");
    }
    
    this.hotelList;
    this.getMasterHotelList(""); //Intial list of hotels for Master Hotel autocomplete.
    this.Getusername();
    this.today = Date.now();
    this.hotelInfolist = [];
    this.windowsServiceVersionlist = [];
    this.latestHeartBeat = undefined;
    localStorage.removeItem("SearchHotelSelected");
  }


  /* In Future - We need to implement for alert message (If error came) */

    
  alertPopupFunction(){
    this.apiCallIdsService
    .readAlertPopup(this.Userid)
    .subscribe((data) => {
      console.log('readAlertPopup =',data[0])
      if(data[0].status == 'Error'){
        console.log('Alert false')
        this.displayAlertPopup = false
      }else{
        console.log('Alert true')
        this.alertData = data
        this.idsProductList=data;
        this.filterProperty = this.idsProductList
        this.dataSource = new MatTableDataSource(this.idsProductList);
        console.log('this.dataSource =', this.dataSource)
        this.displayAlertPopup = true
      }
    });
  }

  alertPopupBtn(){
    this.displayAlertPopup = false
  }
  alertHyperink() {
    this.displayAlertPopup = false
    this.route.navigate(["/redAlertAudit"]);
  }
  public hotellist: AuthStatus[];

  onSelection1() {
    localStorage.setItem("HotelCode", this.selected);
    return this.route.navigate(["/dashboard"]);
  }

  redirectTo(uri: string) {
    this.route
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() => this.route.navigate([uri]));
  }

  GetSelectedHotelName() {
    for (let hotel of this.hotellist) {
      if (hotel.id == this.selected) {
        return hotel.name;
      }
    }
  }

  Getproductbyuid(userIDorHotelId: string, searchKey: string) {
    //alert('userIDorHotelId = '+userIDorHotelId)
    //alert('searchKey = '+searchKey)
    this._APISERVICE
      .gethotelbyuid()
      .subscribe((data) => {
        this.lstproduct = data;
        console.log('Search Data', this.lstproduct)
        for (let x of this.lstproduct) {
          if (this.menuheaders){
            this.menuheaders.push(x.name);
          } 
        }
        this.dismenuheaders = this.menuheaders.filter(
          
          (x, i, a) => a.indexOf(x) == i
          
        );

        console.log(this.dismenuheaders)
      });
  }
  //Indhuj 10-02-2026 Start-- below method for load the menu for particular user 
  Getproductbyuidforparticularuser(userIDorHotelId: string, searchKey: string) {
    //alert('userIDorHotelId = '+userIDorHotelId)
    //alert('searchKey = '+searchKey)
    console.log("loginuserid",userIDorHotelId)
    this._APISERVICE
      .getMenuforparticularuser(userIDorHotelId)
      .subscribe((data) => {
        this.lstproduct = data;
        console.log('Search Data', this.lstproduct)
        for (let x of this.lstproduct) {
          if (this.menuheaders){
            this.menuheaders.push(x.name);
          } 
        }
        this.dismenuheaders = this.menuheaders.filter(
          
          (x, i, a) => a.indexOf(x) == i
          
        );

        console.log(this.dismenuheaders)
      });
  }
   //Indhuj 10-02-2026 End
  Getusername() {
    this._APISERVICE.getusername(this.Userid).subscribe((data) => {
      this.lstuser = data;
      this.user = this.lstuser[0].name;
    });
  }
  FOOTFALL() {
    this.User = localStorage.getItem("Username");
    this.apiCallIdsService
      .getfootfall(this.User, "Signout", "Signout")

      .subscribe((data) => {});
  }
  expandMenu(i) {
    // alert('Expend Menu'+i)
    for (let x of this.lstproduct) {
      x.expand = false;
    }

    // this.lstproduct[i].expand = true;
    return true;
  }
  mouseOverMenuList(){
    console.log('mouse hover')
    this.isSidenavOpened = true;
  }
  mouseOutMenuList(){
    console.log('mouse hover out')
    this.isSidenavOpened = false;
    
  }
  expandSideBar(){
    $('.hamberger').toggleClass("click");
    $('.sidenav').toggleClass("show");
  }
  accordionToggle(index:number){
      $('#accordionCustom'+ index).toggleClass("active");
      $('#accordionCustom' + index).next().slideToggle(200);
  }
  // expandMenu(i) {
  //   for (let x of this.itemList) {
  //     x.expanded = false;
  //   }
  //   this.itemList[i].expanded = true;
  // }
}